import AppTable from '@/components/AppTable';
import { formatPeriod, columnSorter } from '@/utils/formatters';
import { Typography } from 'antd';
import React from 'react';

function PrizeTable({ dataSource, loading, onClick = () => {} }) {
  const columns = [
    {
      title: 'No. ',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      sorter: columnSorter('id'),
      render: (value) => (value ? value : '-'),
    },
    {
      title: 'Prize Name',
      dataIndex: 'name',
      key: 'name',
      sorter: columnSorter('name'),
      render: (name, record, index) => {
        return <Typography.Link onClick={() => onClick?.(record)}>{name}</Typography.Link>;
      },
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type) => (+type === 1 ? 'Topup' : 'Physical'),
      sorter: columnSorter('type'),
    },
    {
      title: 'Prize Quantity',
      dataIndex: 'num_prize',
      key: 'num_prize',
      sorter: columnSorter('num_prize'),
      render: (value) => (value ? value : '0'),
    },
    {
      title: 'Redeemed Quantity',
      dataIndex: 'num_received',
      key: 'num_received',
      sorter: columnSorter('num_received'),
      render: (value) => (value ? value : '0'),
    },
    {
      title: 'Period',
      key: 'period',
      render: (record) => {
        return formatPeriod(record.start_date, record.end_date);
      },
    },
  ];

  return (
    <AppTable
      tableTitle={<h3 className="font-medium">Prizes</h3>}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      hasPagination={false}
    />
  );
}

export default PrizeTable;
